






















































import {Vue, Component, Prop} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {Admin} from '@/types';

const adminModule = namespace('admin');

@Component
export default class PasswordUpdate extends Vue {
  @adminModule.Getter('admin') private admin!: Admin;

  private initOver = false;

  @Prop() private dimmed?: boolean;
  @Prop() private mustFlg?: boolean;
  private get layerStyle() {
    if (this.mustFlg) {
      return 'width:750px; max-height:500px; scroll-y:auto';
    } else {
      return 'width:850px; max-height:600px; scroll-y:auto';
    }
  }
  @Prop() private showFlg!: boolean;
  private closePop() {
    this.$emit('update:showFlg', false);
  }

  // 현재 비밀번호
  private currentPassword = '';
  // 새 비밀번호
  private newPassword = '';
  private newPasswordGuides = '';
  private focusNewPwd() {
    this.newPasswordGuides = 'guide';
  }
  private checkNewPwd() {
    this.newPasswordGuides = '';
    if (this.newPassword.length < 8) {
      this.newPasswordGuides = 'err_length';
    } else {
      const result = this.validatePassword();
      if (result !== 'SUCCESS') {
        this.newPasswordGuides = result;
      }
    }

    if (this.newPasswordConfirm.length > 0) {
      this.changeNewPwdCfm();
    }
  }

  // 새 비밀번호 확인
  private newPasswordConfirm = '';
  private newPasswordConfirmGuides = '';
  private focusNewPwdCfm() {
    if (this.newPasswordConfirmGuides !== 'pass' && this.newPasswordConfirmGuides !== 'fail') {
      this.newPasswordConfirmGuides = 'guide';
    }
  }
  private changeNewPwdCfm() {
    this.newPasswordConfirmGuides = '';
    if (this.newPassword.length > 0 && this.newPassword === this.newPasswordConfirm) {
      this.newPasswordConfirmGuides = 'pass';
    } else {
      this.newPasswordConfirmGuides = 'fail';
    }
  }

  // 비밀번호 변경
  private changePwd() {
    if (this.checkAll()) {
      const request = {
        data: {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword
        }
      };

      this.$api
        .putAdminsPassword(request)
        .then(() => {
          alert(this.$t('PASSWORD_CHANGE_SUCCESS_MSG'));
          this.closePop();
        })
        .catch(() => {
          this.currentPassword = '';
          this.newPassword = '';
          this.newPasswordGuides = '';
          this.newPasswordConfirm = '';
          this.newPasswordConfirmGuides = '';
        });
    }
  }
  private checkAll() {
    if (this.currentPassword.length === 0) {
      alert(this.$t('PASSWORD_CHANGE_ERR_CURRENT_PWD_EMPYT'));
      return false;
    }
    if (this.newPassword.length === 0) {
      alert(this.$t('PASSWORD_CHANGE_ERR_NEW_PWD_EMPYT'));
      return false;
    }
    if (this.newPasswordConfirm.length === 0) {
      alert(this.$t('PASSWORD_CHANGE_ERR_NEW_PWD_CONFIRM_EMPYT'));
      return false;
    }
    if (!this.mustFlg && this.newPasswordGuides === 'err_length') {
      alert(this.$t('PASSWORD_CHANGE_ERR_NEW_PWD_LENGTH2'));
      return false;
    }
    if (this.newPasswordConfirmGuides === 'fail') {
      alert(this.$t('PASSWORD_CHANGE_NEW_PWD_CONFIRM_GUID'));
      return false;
    }
    if (this.mustFlg && this.newPassword.length < 8) {
      alert(this.$t('PASSWORD_CHANGE_ERR_NEW_PWD_LENGTH'));
      return false;
    }
    const result = this.validatePassword();
    if (result !== 'SUCCESS') {
      if (result === 'not_allow_special') {
        alert(this.$t('PASSWORD_CHANGE_NEW_PWD_ERR_4'));
      } else if (result === 'complexity_at_least3') {
        alert(this.$t('PASSWORD_CHANGE_NEW_PWD_ERR_3'));
      } else if (result === 'complexity_at_least2') {
        alert(this.$t('PASSWORD_CHANGE_NEW_PWD_ERR_2'));
      }
      return false;
    }
    if (this.currentPassword === this.newPassword) {
      alert(this.$t('PASSWORD_CHANGE_ERR_PWD_REPEAT'));
      this.currentPassword = '';
      this.newPassword = '';
      this.newPasswordGuides = '';
      this.newPasswordConfirm = '';
      this.newPasswordConfirmGuides = '';
      return false;
    }
    return true;
  }

  private validatePassword() {
    const patternNumber = /[0-9]/g;
    const patternEnglish = /[a-zA-Z]/gi;
    const patternSpecial = /[!@#$%^&+=\-_.()]/g;

    const checkNumber = patternNumber.test(this.newPassword) ? 1 : 0;
    const checkEnglish = patternEnglish.test(this.newPassword) ? 1 : 0;
    const checkSpecial = patternSpecial.test(this.newPassword) ? 1 : 0;
    const checkSum = checkNumber + checkEnglish + checkSpecial;

    const filteringPassword = this.newPassword
      .replace(patternNumber, '')
      .replace(patternEnglish, '')
      .replace(patternSpecial, '');

    let result = 'SUCCESS';
    if (filteringPassword.length > 0) {
      result = 'not_allow_special';
    } else {
      if (this.newPassword.length < 10) {
        if (checkSum < 3) {
          result = 'complexity_at_least3';
        }
      } else if (checkSum < 2) {
        result = 'complexity_at_least2';
      }
    }

    return result;
  }

  private async mounted() {
    $('body').addClass('no-scroll');

    this.initOver = true;
  }
  beforeDestroy() {
    $('body').removeClass('no-scroll');
  }
}
